<template>
  <el-menu
    router
    :default-active="$route.path"
    class="el-menu-vertical-demo"
    background-color="#353535"
    text-color="#fff"
    active-text-color="#00C0FF"
    v-if="userData.permissions"
  >
    <!-- "productManage",		//商品管理
    "homeData",				//首页统计
    "financeManage",		//财务管理
    "orderManage",			//订单管理
    "systemManage",			//系统设置
    "orgManage",			//机构管理
    "memberManage"			//会员管理 -->
    <el-menu-item
      index="/home"
      v-if="userData.permissions.indexOf('homeData1111') != -1"
    >
      首页
    </el-menu-item>
    <el-menu-item
      index="/user"
      v-if="userData.permissions.indexOf('memberManage') != -1"
    >
      会员
    </el-menu-item>
    <el-submenu
      index="2"
      v-if="userData.permissions.indexOf('productManage') != -1"
    >
      <template slot="title">商品管理</template>
      <el-menu-item index="/product">商品列表</el-menu-item>
      <!-- <el-menu-item index="/addProduct">商品发布</el-menu-item> -->
      <el-menu-item index="/category">分类管理</el-menu-item>
      <el-menu-item index="/directSell">厂家直销</el-menu-item>
      <el-menu-item index="/storeProduct">门店商品</el-menu-item>
    </el-submenu>
    <!-- <el-menu-item index="/newOrder">
                新订单
      </el-menu-item> -->
    <el-submenu
      index="10"
      v-if="userData.permissions.indexOf('orderManage') != -1"
    >
      <template slot="title">订单管理</template>
      <el-menu-item
        index="/orders"
        v-if="userData.permissions.indexOf('orderManage') != -1"
      >
        销售订单
      </el-menu-item>
      <el-menu-item
        index="/groupOrders"
        v-if="userData.permissions.indexOf('orderManage') != -1"
      >
        团购订单
      </el-menu-item>
      <el-menu-item
        index="/storeStockOrder"
        v-if="userData.permissions.indexOf('orderManage') != -1"
      >
        进货订单
      </el-menu-item>
      <el-menu-item
        index="/homeOrder"
        v-if="userData.permissions.indexOf('orderManage') != -1"
      >
        家庭订单
      </el-menu-item>
    </el-submenu>

    <!-- <el-menu-item index="/order">
                订单管理原来的
      </el-menu-item> -->
    <!-- <el-menu-item index="/JDOrder">
                京东订单
      </el-menu-item> -->
    <el-menu-item
      index="/supplier"
      v-if="userData.permissions.indexOf('orgManage') != -1"
    >
      机构管理
    </el-menu-item>
    <el-menu-item
      index="/goodUnit"
      v-if="userData.permissions.indexOf('orgManage') != -1"
    >
      计次商品提审记录
    </el-menu-item>
    <el-menu-item
      index="/permission"
      v-if="userData.permissions.indexOf('roleManage') != -1"
    >
      登录权限
    </el-menu-item>
    <el-submenu
      index="3"
      v-if="userData.permissions.indexOf('financeManage') != -1"
    >
      <template slot="title">财务统计</template>

      <el-menu-item index="/finance/store">门店提现</el-menu-item>
      <el-menu-item index="/finance/userWithdraw">市场提现</el-menu-item>
      <el-menu-item index="/finance/bonus">红利统计</el-menu-item>
      <el-menu-item index="/qtManage">价值配额</el-menu-item>
      <el-menu-item index="/finance/coupon">优惠卷转账</el-menu-item>
      <el-menu-item index="/finance/accountChange">账户变更</el-menu-item>
      <el-menu-item index="/finance/consumptionRecord">消费礼包记录</el-menu-item>
      <el-menu-item index="/finance/businessSubsidiesRecord">消费礼包补贴记录</el-menu-item>
    </el-submenu>
    <!-- <el-menu-item index="/balance" v-if="userData.permissions.indexOf('financeManage') != -1">
                财务管理
      </el-menu-item> -->
    <el-submenu
      index="4"
      v-if="userData.permissions.indexOf('productManage') != -1"
    >
      <template slot="title">门店管理</template>
      <el-menu-item index="/store/add">添加门店</el-menu-item>
      <el-menu-item index="/store/audit">门店审核</el-menu-item>
      <el-menu-item index="/store/list">门店列表</el-menu-item>
      <el-menu-item index="/store/category">门店分类</el-menu-item>
      <el-menu-item
        index="/store/delivery"
        v-if="userData.permissions.indexOf('memberManage') != -1"
      >
        配送管理
      </el-menu-item>
    </el-submenu>
    <el-submenu
      index="5"
      v-if="userData.permissions.indexOf('productManage1') != -1"
    >
      <template slot="title">门店订单</template>
      <el-menu-item index="/store/order/quick">快捷买单</el-menu-item>
      <el-menu-item index="/store/order/pick">自提订单</el-menu-item>
      <el-menu-item index="/storeOrder/PagePsPick">配送订单</el-menu-item>
    </el-submenu>
    <el-submenu
      index="6"
      v-if="userData.permissions.indexOf('systemManage') != -1"
    >
      <template slot="title">系统设置</template>
      <el-menu-item index="/system">轮播图</el-menu-item>
      <el-menu-item index="/productArea">商品专区</el-menu-item>
      <el-menu-item index="/appManage">APP管理</el-menu-item>
      <el-menu-item index="/indexManage">首页管理</el-menu-item>
      <el-menu-item index="/indexPinpai">品牌分类</el-menu-item>
    </el-submenu>
    <el-submenu
      index="7"
      v-if="userData.permissions.indexOf('systemManage1') != -1"
    >
      <template slot="title">技师管理</template>
      <el-menu-item index="/teache/list">技师列表</el-menu-item>
      <el-menu-item index="/teache/add">添加技师</el-menu-item>
      <el-menu-item index="/teache/category">技师分类</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import { ERR_POST, ERR_BOSS } from "api/config";
export default {
  data() {
    return {
      personnelShow: false,
      isBoss: false,
      userData: {},
    };
  },
  mounted() {
    this.userData = JSON.parse(window.localStorage.getItem("getUserInfo"));
    // console.log(this.userData);
  },
  methods: {
    handleSelect(key, keyPath) {},
    handleCommand(command) {
      // this.$message('click on item ' + command);
      this.signOut();
    },
    signOut() {
      window.localStorage.removeItem("getUserInfo");
      let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
      let _this = this;
      if (!getUserInfo) {
        this.$message("退出成功");
        setTimeout(function () {
          _this.$router.push({
            path: "/",
          });
        }, 2000);
      }
    },
  },
};
</script>

<style lang="stylus">
.el-menu-vertical-demo {
  width: 10%;
  height: 90%;
  display: inline-block;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  overflow-y: visible;

  .el-menu-item {
    padding-left: 10px;
    color: #ff0000;
  }

  .el-menu-item.is-active {
    color: #ff0000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/sidebar.vue